import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  rounded: {
    borderRadius: "99em",
  },
}))

export default styles
